import styled, { css } from 'styled-components';

import {
    spaceMixin,
    token,
    mediaMixin,
    Button,
} from '@zillow/constellation';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${spaceMixin('sm')} 0;
    padding: ${spaceMixin('sm')};
    min-height: 122px;
    border: 1px solid ${token('colors.gray300')};
    border-bottom: 6px solid ${token('colors.brand')};

    ${mediaMixin('lg', css`
        flex-direction: row;
    `)}
`;

export const ContentContainer = styled.div`
    ${mediaMixin('lg', css`
        margin-right: 50px;
    `)}
`;

export const BannerButtonContainer = styled.div`
    ${mediaMixin('lg', css`
        align-self: center;
        margin-left: auto;
    `)}
`;

export const ButtonTryKeepe = styled(Button)`
    padding: 4px 16px;
    width: 100%;
    height: auto;
    white-space: nowrap;
`;
